import React from 'react';
import PropTypes from 'prop-types';
import { INSTRUCTION } from '../../../constants/shared/CommonConstants';
import '../shared/Instruction.scss';

const { GROUPS, STUDENTS } = INSTRUCTION;

const MESSAGE = {
    [GROUPS]: (
        <div>
            Educators, you can continue using mCLASS Instruction. The following grouping
            recommendations use MOY Benchmark results and Progress Monitoring results collected
            between the start of MOY and the start of EOY. If needed, educators can make adjustments
            to groups outside of mCLASS based on professional judgments from EOY scores.
        </div>
    ),
    [STUDENTS]: (
        <div>
            Educators, you can continue using mCLASS Instruction. The following observed patterns
            use MOY Benchmark results and Progress Monitoring results collected between the start of
            MOY and the start of EOY.
        </div>
    ),
};

const MESSAGE_EMPTY_DATA = {
    [GROUPS]: (
        <div>
            Grouping recommendations are only available for students who completed MOY assessment.
        </div>
    ),
    [STUDENTS]: (
        <div>Observed patterns are only available for students who completed MOY assessment.</div>
    ),
};

const SecureResultsBox = ({ selectedTab, closeBanner, isOpenOnTab, isEmptyDataMessage }) => {
    return (
        Object.keys(MESSAGE).includes(selectedTab) && (
            <div className="secure-result-box">
                <i className="icon-v2-messaging-info" />
                <div className="body">
                    {isEmptyDataMessage ? MESSAGE_EMPTY_DATA[selectedTab] : MESSAGE[selectedTab]}
                </div>
                <button
                    type="button"
                    className="btn-icon-ghost"
                    onClick={() => closeBanner({ ...isOpenOnTab, ...{ [selectedTab]: false } })}
                >
                    <i alt="Close infobox" className="icon-v2-close" />
                </button>
            </div>
        )
    );
};

SecureResultsBox.defaultProps = {
    selectedTab: '',
    closeBanner: () => {},
    isOpenOnTab: {},
    isEmptyDataMessage: false,
};

SecureResultsBox.propTypes = {
    selectedTab: PropTypes.string,
    closeBanner: PropTypes.func,
    isOpenOnTab: PropTypes.objectOf(PropTypes.bool),
    isEmptyDataMessage: PropTypes.bool,
};

export default SecureResultsBox;
